namespace GeniuzPOS.Product {
    export interface CsDocTypeRow {
        Id?: number;
        DocType?: string;
        DocName?: string;
        DocPrefix?: string;
        DocGroup?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        CODE?: string;
        FullName?: string;
    }

    export namespace CsDocTypeRow {
        export const idProperty = 'DocType';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsDocType';
        export const lookupKey = 'Product.CsDocType';

        export function getLookup(): Q.Lookup<CsDocTypeRow> {
            return Q.getLookup<CsDocTypeRow>('Product.CsDocType');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            DocType = "DocType",
            DocName = "DocName",
            DocPrefix = "DocPrefix",
            DocGroup = "DocGroup",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            CODE = "CODE",
            FullName = "FullName"
        }
    }
}
